<template>
  <div style="width:100%; border-radius: 0.5rem;">
    <custom-automation-node
      :data="data"
      icon="pi-comments"
      nodeType="action"
      color="#2D54F8"
      title="שליחת הודעה מותאמת אישית"
      @remove="remove">
      <div v-if="!editMode" class="flex gap-2 w-full mt-4 bg-gray-200 rounded-lg ">

        <span
v-if="smsMessage !== ''"
class="whitespace-nowrap overflow-ellipsis w-max overflow-hidden p-3"
              v-html="smsMessage"/>
        <span v-else class="w-max p-3">יש להזין הודעה</span>

        <span
          class="bg-gray-300 px-2 my-2 ml-3 rounded-xl flex justify-center mr-auto items-center border border-solid border-gray-400"
          @click="editMode = !editMode">
          עריכה
        </span>
      </div>
      <div
        v-if="editMode"
        class="mt-4 flex flex-col w-full gap-2">
        <span class="font-medium">עריכת הודעה</span>
        <sms-message-box
          :filterTags="filterTags"
          :preMessage="smsMessage"
          @save-message="saveMessageContent"/>
      </div>
    </custom-automation-node>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, PropType, ref} from "vue";
import {SmsAutomationActions, SmsParameters, smsParametersList} from "@torim-app/types";
import {replaceAll} from "@torim-app/utils";

export default defineComponent({
  name: "BeginNode",
  props: {
    data: {
      type: Object as PropType<Record<string, any>>,
      required: false,
    }
  },
  emits: ['remove', 'update-sms-message'],
  setup(props, {emit}) {
    const editMode = ref(false);
    const filterTags = [SmsParameters.CUSTOMER_NAME];

    const smsMessage = computed<string>(() => {
      if (props.data?.additionalParams?.message) {
        let formattedMessage = props.data.additionalParams?.message;
        for (const tag of smsParametersList)
          if (formattedMessage.includes(tag)) {
            formattedMessage = replaceAll(formattedMessage, tag, `<span class='mention'>${tag}</span>`)
          }

        return formattedMessage;
      }
      return '';
    })

    const saveMessageContent = (message: string) => {
      emit('update-sms-message', message);
      editMode.value = false;
    }

    const remove = () => {
      emit('remove')
    }

    return {
      remove, smsMessage, editMode, SmsAutomationActions, filterTags, saveMessageContent
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@assets/css/vars.scss' as *;

.mention {
  border-radius: 0.5rem;
  padding: 0.25rem 0.5rem;
  background-color: $third-color;
}

</style>
